import { ListAlt } from "@material-ui/icons";
import { PlanList } from "./list";
import { PlanEdit } from "./edit";

export const PlanIcon = ListAlt;

export { PlanList, PlanEdit };
